
import React, {useEffect, useState } from 'react';

import Alert from 'react-bootstrap/Alert'
import CardArranger from './CardArranger';
import Card from 'react-bootstrap/Card';
import Breadcrumb from 'react-bootstrap/Breadcrumb';




import { useTranslation } from 'react-i18next';

function renderServiceCategory(res, t) {
    let onClick = (x) => {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('serviceType', res[0]);
        window.location.search = urlParams;
    }

    //<Card.Text>Opis kategorii tutaj</Card.Text>
    return <Card className="h-100"
            onClick={() => onClick(res[0])} 
            style={{ cursor: "pointer" }}>
                <Card.Body>
                    <Card.Title>{res[0]}</Card.Title>                                
                    
                </Card.Body>
            </Card>
}


function renderClientType(res, t) {
    let onClick = (x) => {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('clientType', res[0]);
        window.location.search = urlParams;
    }

    return <Card className="h-100"
        //<Card.Text>Opis klienta tutaj</Card.Text>
        onClick={() => onClick(res[0])} 
            style={{ cursor: "pointer" }}>
                <Card.Body>
                    <Card.Title>{res[0]}</Card.Title>                                
                </Card.Body>
            </Card>
}


export function clearQueryParams(params, reload=false) {
    console.log("Called with", params)
    debugger;
    let urlParams = new URLSearchParams(window.location.search);
    for (const p of Array.from(urlParams.keys())) {
        if (params.includes(p)) {
            urlParams.delete(p)     
        }
    }

    let fp = window.location.pathname;
    if (urlParams.toString()) {
        fp += "?" + urlParams.toString()
    }
    window.history.pushState({}, document.title, fp);
    if (reload) {
        window.location.reload()
    }
}

export const supportedStateKeys = ["serviceType", "clientType", "entryID"]

function EntriesBrowser(props) {

    const { t } = useTranslation();


    const [state, setState] = useState({})



    let startBreadcrumb = 
       <Breadcrumb.Item onClick={() => clearQueryParams(["serviceType", "clientType"], true)} >{t("breadcrumbStart")}</Breadcrumb.Item>;
    let servicetypeBreadcrumb = 
       <Breadcrumb.Item onClick={() => clearQueryParams(["serviceType"], true)} >{t("breadCrumbServiceType")}</Breadcrumb.Item>

    useEffect(() => {
        
        let currentState = {...state}
        const hashParams = new URLSearchParams(window.location.search);

        for (const key of supportedStateKeys) {
            const val = hashParams.get(key);
            if (val !== null) {
                currentState[key] = val
            } else {
                delete currentState[key];
            }
        }

        setState(currentState)
      }, []);


    // return, as data validation is not possible
    if (!props.hasOwnProperty("clientTypes")) {
        return;
    }


    // return, as data validation is not possible
    if (!props.hasOwnProperty("serviceTypes")) {
        return;
    }
    if (state.hasOwnProperty("entryID")) {
        // render specific entry
        const _id = state["entryID"];
        let url = '/getById?' + new URLSearchParams({
                    entryID: _id,
        })

        fetch(url)
                    .then(res => res.json())
                    .then(
                        (result) => {
                            // Below calls result in rendering SearchResults component
                            // in the top level logic (App.js) instead of EntriesBrowser
                            props.setResults(result); 
                            if (result.length === 0) {
                                props.setResultsEmpty(true)
                            } else {
                                props.setResultsEmpty(false)
                            }

                           
                        },
                        (error) => {
                            console.log("ERRR", error) // TODO
                        }
                    )

    }  else {
        
        if (state.hasOwnProperty("serviceType")) {
            const serviceType = state["serviceType"];
            if (!props.serviceTypes.includes(serviceType)) {
                // TODO: 
                // remove serviceType and clientType from url hash part
                // remove also from state       
                // return ?
                     
            }

            if (state.hasOwnProperty("clientType")) {
                const clientType = state["clientType"]
                if (!props.clientTypes.includes(clientType))  {
                    // TODO: remove clientType from url hash part and from state
                    // return?
                }

                let url = '/query?' + new URLSearchParams({
                    q: "",
                    clientTypes: [state.clientType],
                    serviceTypes: [state.serviceType],
                    lng: props.language
                })
    
                fetch(url)
                    .then(res => res.json())
                    .then(
                        (result) => {
                            // Below calls result in rendering SearchResults component
                            // in the top level logic (App.js) instead of EntriesBrowser
                            props.setResults(result); 
                            if (result.length === 0) {
                                props.setResultsEmpty(true)
                            } else {
                                props.setResultsEmpty(false)
                            }

                           
                        },
                        // Note: it's important to handle errors here
                        // instead of a catch() block so that we don't swallow
                        // exceptions from actual bugs in components.
                        (error) => {
                            console.log("ERRR", error) // TODO
                            //props.setResults([])
                            //props.setResultsEmpty(false)
                        }
                    )



            } else {
                // we got service type selected, now render all client types
                return (
                    <>
                    <Card>
                        <Card.Body>
                          <Breadcrumb>
                            { startBreadcrumb }
                            { servicetypeBreadcrumb }
                            <Breadcrumb.Item active>{t("selectClientType")}</Breadcrumb.Item>
                            </Breadcrumb>                 
                         </Card.Body>
                    </Card>


                    <CardArranger render={(res) => renderClientType(res, t)} 
                                         results={props.clientTypes} 
                                         columns={1}>                
                    </CardArranger>
                    </>
                )

            }

            //  <Alert variant='light' className='mt-2 text-center'>{t("selectServiceType")}</Alert>
        } else {
            // render service types

            return (
            <>
            <Card>
                <Card.Body>
                    <Breadcrumb>
                        { startBreadcrumb }
                        <Breadcrumb.Item active>{t("selectServiceType")}</Breadcrumb.Item>
                    </Breadcrumb>                 
                </Card.Body>
            </Card>
            <CardArranger render={(res) => renderServiceCategory(res, t)} 
                                 results={props.serviceTypes} 
                                 columns={1}>
                            
                    </CardArranger>
                    </>
            )
        }


    }





    return <Alert variant='light' className='mt-2 text-center'></Alert>
}


export default EntriesBrowser;
